import { Outlet } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Grid, Box, Paper } from '@mui/material';
import MainContentHeader from 'src/shared/components/atoms/mainContentHeader';
import GridWrapper from 'src/shared/components/organisms/gridWrapper';
import PageTabNavigation, { PageTabItem } from 'src/shared/components/navigations/pageTabNavigation';
import { RoutesEnum } from 'src/shared/models/enums/routes.enum';
import GroupMessageSmsActionButtons from '../components/groupMessageSmsActionButtons';

const smsPageTabs: PageTabItem[] = [
  { label: 'groupMessage:sms.sections.sms', route: RoutesEnum.GroupMessageSmsOverview },
  { label: 'groupMessage:sms.sections.unsubscribed', route: RoutesEnum.GroupMessageSmsUnsubscribed },
];

export const GroupMessageSmsPage = () => {
  const { t } = useTranslation(['groupMessage']);

  return (
    <GridWrapper>
      <Grid item xs='auto'>
        <MainContentHeader title={t('groupMessage:sms.overview.header')} />
      </Grid>
      <Grid item xs sx={{ display: 'flex', justifyContent: 'flex-end' }}>
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-end' }}>
          <GroupMessageSmsActionButtons />
        </Box>
      </Grid>
      <Grid item xs={12}>
        <Paper>
          <PageTabNavigation pageTabs={smsPageTabs} />
          <Outlet />
        </Paper>
      </Grid>
    </GridWrapper>
  );
};
